import moment from 'moment'

const formatDateTime = (dateTime, configuration = `D MMM YYYY`) =>
  moment(dateTime).format(configuration)

const transformPostToCard = post => {
  const hasFullDateLocation = post.eventTime && post.eventLocation

  const formattedTime = formatDateTime(post.eventTime)

  const eventDate =
    (hasFullDateLocation && `${formattedTime}, ${post.eventLocation}`) ||
    formattedTime ||
    post.eventLocation ||
    'Date and location TBA'

  const postCategories =
    post?.categories.length > 0 && post.categories.map(({ title }) => title)

  const isEvent =
    postCategories.findIndex(category => category.title === 'Event') > -1

  return {
    ...post,
    link: {
      url: post.path,
      displayText: 'Read More'
    },
    contentNode: post?.excerptNode,
    date: isEvent ? eventDate : formatDateTime(post?.meta?.publishedAt),
    subheading: post?.categories.length > 0 && post.categories
  }
}

const removeDuplicatesByTitle = array =>
  Array.from(new Set(array.map(a => a.title))).map(title => {
    return array.find(a => a.title === title)
  })

const configCategoriesForSelect = items =>
  items.map(({ slug, title }) => ({
    value: slug,
    text: title
  }))

const shuffleArray = array => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1)) // random index from 0 to i

    // swap elements array[i] and array[j]
    // we use "destructuring assignment" syntax to achieve that
    // same can be written as:
    // let t = array[i]; array[i] = array[j]; array[j] = t
    ;[array[i], array[j]] = [array[j], array[i]]
  }

  return array
}

export {
  transformPostToCard,
  removeDuplicatesByTitle,
  configCategoriesForSelect,
  formatDateTime,
  shuffleArray
}
